import React, { Component, PropTypes } from 'react';

import { NitroHeading } from 'nitro-components';

import styled from 'styled-components';

const FilterSectionWrapper = styled.section`
  margin-bottom: 48px;
`;

class FilterSection extends Component {
  onChange = newFilter => {
    if (this.props.action) {
      this.props.action(this.props.index, newFilter);
    }
  };

  render() {
    const { index, filters } = this.props;
    const filter = filters[index];

    const FilterComponent = filter.component;

    const extraProps = filter.componentProps;

    return (
      <FilterSectionWrapper>
        <NitroHeading size="3" label={filter.title} margin="8" />
        <FilterComponent
          action={this.onChange}
          filter={filter}
          filters={filters}
          {...extraProps}
        />
      </FilterSectionWrapper>
    );
  }
}

FilterSection.propTypes = {
  filters: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
  action: PropTypes.func
};

export default FilterSection;



// WEBPACK FOOTER //
// ./src/components/filter/FilterSection.js